import Calendar from "color-calendar";
//import { getRequest } from "../services/getRequest";

const EventsCalendar = () => {
    
    if ( document.getElementById('events-calendar') ) {
        const PRESS_URL = document.getElementById('events-calendar').dataset.url; 

        let app = new Vue({
            el: '#events-calendar',
            data() {
                return {
                  selectedDay: null, // Add state to store selected day
                  events: [
                    // {
                    //   id: 1,
                    //   description: 'Clean the house.',
                    //   date: new Date(2022, 2, 1),
                    //   color: 'red',
                    //   dot: false,
                    // },
                  ],
                };
              },
              computed: {
                attributes() {
                    return this.events.map(t => ({
                        key: `event.${t.id}`,
                        dot: t.dot,
                        dates: t.date,
                        customData: t,
                    }));
                },
            },
            mounted() {
                //this.getEvents();
            },
            methods: {
                getEvents (month,year) {
                    const data = new FormData();
                    if(document.querySelector('.page-template-tpl-academy')){
                        let endpoint_academy = `${PRESS_URL}/wp-json/api/v1/korian_academy`; 
                        fetch( endpoint_academy+'?year='+year+'&month='+ month)
                        .then(res => res.json())
                        .then(data => {
                            this.events = data;
                        });

                    } else {
                        let endpoint_academy = `${PRESS_URL}/wp-json/api/v1/events`; 
                        fetch( endpoint_academy+'?year='+year+'&month='+ month)
                        .then(res => res.json())
                        .then(data => {
                            this.events = data;
                        });
                    }
                },
                pageChange (page) {
                    this.selectedDay = null;
                    this.getEvents(page.month,page.year);
                },
                dayClicked(day) {
                    this.selectedDay = day;
                },
                
              },
        });
        
    }
};

export default EventsCalendar;
